import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from './services/config.service';
import { Mall } from './models/mall';
import { Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { ElasticService } from './services/elastic.service';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {


  constructor(
    private platform: Platform,
    public configService: ConfigService, private elasticService: ElasticService,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.initializeApp();
  }


  // initializeApp() {
  //   this.platform.ready().then(() => {
  //     // Get current path and check if it's the resume page
  //     const currentPath = window.location.pathname;
  //     const isResumePage = currentPath.includes('/resume/');
  //     if (!isResumePage && !window.sessionStorage.getItem('lite_token')) {
  //       const params = new URLSearchParams(window.location.search);
  //       const queryParams: any = {};
  //       const updateData = params.get('update_data');
  //       const pqrs = params.get('pqrs');
  //       if (updateData) queryParams.update_data = updateData;
  //       if (pqrs) queryParams.pqrs = pqrs;

  //       this.router.navigate(['/'], {
  //         queryParams: Object.keys(queryParams).length ? queryParams : undefined,
  //         replaceUrl: true,
  //       });
  //     }
  //     this.elasticService.initElk();
  //     this.configService.loadMall().then((mall: Mall) => {
  //       console.debug(mall);
  //       if (mall?.favicon) {
  //         this.setFavicon(mall.favicon);
  //         this.configService.setSiteKey(mall.captcha_token);
  //       }
  //     }).catch((err) => {
  //       console.debug(err);
  //     });
  //   });
  // }

  initializeApp() {
    this.platform.ready().then(() => {
      // Get current path and check if it's the resume page
      const currentPath = window.location.pathname;
      const isResumePage = currentPath.includes('/resume/');

      if (!isResumePage && !window.sessionStorage.getItem('lite_token')) {

        const params = new URLSearchParams(window.location.search);
        const queryParams: any = {};

        const updateData = params.get('update_data');
        const pqrs = params.get('pqrs');
        const role = params.get('role');

        if (updateData) queryParams.update_data = updateData;
        if (pqrs) queryParams.pqrs = pqrs;
        if (role) queryParams.role = role;

        this.router.navigate([], {
          queryParams: queryParams,
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }

      this.elasticService.initElk();

      this.configService.loadMall()
        .then((mall: Mall) => {
          console.debug(mall);
          if (mall?.favicon) {
            this.setFavicon(mall.favicon);
            this.configService.setSiteKey(mall.captcha_token);
          }
        })
        .catch((err) => {
          console.debug(err);
        });
    });
  }

  setFavicon(url: string) {
    const head = document.querySelector('head');
    const existingLinks = head?.querySelectorAll("link[rel*='icon']");
    existingLinks?.forEach(el => head?.removeChild(el));

    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = url;

    head?.appendChild(link);
  }

}
